import Integracoes from "@/modules/Integracoes/pages/Index";

export default [
  {
    name: "configuracoesIntegracoes",
    path: "/configuracoesIntegracoes",
    component: Integracoes,
    meta: { title: "Apps" },
  },
];
